import React from "react";
import styles from "./DisplayUser.module.css";

// This component will show a user with all the details.
const DisplayUser = ({ handleClick, firstName, lastName, email, role }) => {
  return (
    <div className={styles["display-user"]} onClick={handleClick}>
      <p className={styles["name-wrapper"]}>{firstName + " " + lastName}</p>
      <p className={styles["email-wrapper"]}>{email}</p>
      <p>{role}</p>
    </div>
  );
};

export default DisplayUser;
